import type { CHECK_DEFINITION } from '@/typings/api';

import * as MediaApiModels from './media-api-models';
import type main from './noodleMedia';

export type ApiDefinitions = CHECK_DEFINITION<main>;

export { MediaApiModels };
